//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import linkify from 'linkify-it';

const Linkify = new linkify();

/**
 * Returns all urls (with or without the http:// protocol) found
 * within the given string. Returns undefined if no urls are found.
 *
 * @param inputStr Any string input
 */
export const getAllUrlsFromString = (inputStr: string) => {
  const urlMatch = Linkify.match(inputStr);
  return urlMatch ?? undefined;
};

/**
 * Returns the full url for the first url (with or without the http:// protocol) found
 * within the given string. Returns undefined if no url is found.
 *
 * @param url Any text containing a url
 */
export const normalizeUrl = (url: string) => {
  const urlMatch = Linkify.match(url);
  return urlMatch?.[0]?.url;
};
